import {h, Fragment} from "preact"
export default function Icon({ name, className }) {
    return <i className={`ns-icon ns-icon${name ? `-${name}` : ""} ${className ?? ""}`}></i>
}